export interface StepUpInitiateAuthRequest {
  exampleField?: string;
}

export interface StepUpInitiateAuthResponse {
  preferredMfaMethod: string;
  verified: boolean;
}

export interface StepUpRespondToChallengeRequest {
  code: string;
}

export interface StepUpRespondToChallengeResponse {
  status: 'SUCCESS' | 'FAILURE';
}

export interface AssociateSoftwareTokenResponse {
  secretCode: string;
}

export enum JobStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  TIMED_OUT = 'TIMED_OUT',
  ABORTED = 'ABORTED',
}

export enum UserImportCounts {
  INSERTED = 'INSERTED',
  FAIL = 'FAIL',
  UPDATED = 'UPDATED',
  INACTIVE = 'INACTIVE',
}

export enum JobType {
  ImportUsers = 'ImportUsers',
}

export type Job = {
  jobType: string;
  orgId: string;
  jobId: string;
  jobDescr: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
  jobTypeVersion: string;
  jobEnvelope: string;
  payload: any;
  stepFunctionError?: string;
  stepFunctionErrorCause?: string;
}

export * from './stepUp';
export * from './jobs'; 